angular.module('kareo.ui.shared.directives.patient-nav.services', [])
  .factory('kPatientNavUrlFor', () => {
    function facesheet(patientId) {
      return '/facesheet-ui/api/viewFacesheet/patient/' + patientId;
    }

    function history(patientId) {
      return '/EhrWebApp/patients/viewPatientHistory/' + patientId;
    }

    function problems(patientId) {
      return '/EhrWebApp/patients/viewProblems/' + patientId;
    }

    function medications(patientId) {
      return '/patients/' + patientId + '/medications';
    }

    function immunizations(patientId) {
      return '/EhrWebApp/patients/viewImmunizations/' + patientId;
    }

    function allergies(patientId) {
      return '/EhrWebApp/patients/viewAllergies/' + patientId;
    }

    function vitals(patientId) {
      return '/EhrWebApp/patients/viewVitals/' + patientId;
    }

    function noteslist(patientId) {
      return '/notes-ui/#/notes-list/' + patientId;
    }

    function noteslistOld(patientId) {
      return '/patients/' + patientId + '/notes';
    }

    function labs(patientId) {
      return '/labs-ui/#/patient/' + patientId + '/labState/all';
    }

    function demographics(patientId) {
      return '/EhrWebApp/patients/viewProfile/' + patientId;
    }

    function billingProfiles(patientId) {
      return '/billing-profiles-ui/#/billing-profiles/' + patientId + '/insurance';
    }

    function patientAlerts(patientId) {
      return '/billing-profiles-ui/#/billing-profiles/' + patientId + '/patient-alert';
    }

    function patientPatientAccountHistory(patientId) {
      return '/billing-profiles-ui/#/billing-profiles/' + patientId + '/patient-account-history';
    }

    function carechecklist(patientId) {
      return '/EhrWebApp/patients/viewFlowSheets/' + patientId;
    }

    function documents(patientId) {
      return '/EhrWebApp/patients/viewDocuments/' + patientId;
    }

    function patientRecall(patientId) {
      return '/admin-ui/#/recall/' + patientId;
    }

    function flowsheets(patientId) {
      return '/flowsheets-ui/#/' + patientId;
    }

    function careTeam(patientId) {
      return '/patient-history-ui/' + patientId + '/care-team';
    }

    return {
      facesheet,
      history,
      problems,
      medications,
      immunizations,
      allergies,
      vitals,
      noteslist,
      noteslistOld,
      labs,
      demographics,
      billingProfiles,
      patientAlerts,
      patientPatientAccountHistory,
      carechecklist,
      documents,
      patientRecall,
      flowsheets,
      careTeam
    };
  })
  .service('PatientNavPatientService', [
    '$http', function ($http) {
      var patientApiURL = '/notes-ui/api/Patient';
      var patientBalanceApiUrl = '/payments-ui/api/PatientPayment/balance';
      this.getPatient = function (patientId) {
        return $http.get(patientApiURL + '/' + patientId).then((response) => {
          return response.data;
        });
      };
      this.getPatientBalance = function (patientId) {
        return $http.get(patientBalanceApiUrl + '/' + patientId)
          .then((response) => {
            return response.data;
          });
      };
      this.getPatientPhotoUrl = function (patientId) {
        return patientApiURL + '/' + patientId + '/Photo/Img128';
      };
    }]);
